/*
 * @Description: 
 * @Version: 2.0
 * @Autor: sen.yang
 * @Date: 2021-12-17 13:48:36
 * @LastEditors: sen.yang
 * @LastEditTime: 2021-12-22 15:37:38
 */
const pickUp = [
    {
      path: '/pickup/add',
      name: 'pickupAdd',
      component: () => import('../views/pickUp/add.vue'),
    },
    {
      path: '/address/add',
      name: 'addressAdd',
      component: () => import('../views/address/add.vue'),
    },
  ]
  export default pickUp


// WEBPACK FOOTER //
// ./src/router/pickUp.js